module.exports = __webpack_public_path__ + "img/exp-company.4c88548e.svg";